import { BodyP } from '@/components/Typography'

import LoanForm from './LoanForm'
import LoanResult from './LoanResult'
import { SimulatorStyles } from './styles'

const Simulator = () => (
  <SimulatorStyles>
    <div className="container eu-sm-1">
      <LoanForm className="form" />
      <LoanResult className="loan-result" />
    </div>

    <BodyP color="dark-high" className="disclaimer">
      <span aria-hidden>*</span>Sujeito a análise de crédito
    </BodyP>
  </SimulatorStyles>
)
export default Simulator
